export enum CLocation {
  /**
   * 打印结束后不定位，直接停止
   */
  NO_LOCATION,
  /**
   * 打印结束后定位到标签分割线，如果无缝隙，最大进纸skip个dot后停止(1mm==8dot)
   */
  SKIP ,
}
